import { useEffect } from 'react';

export default function useRefresh(navigate: any, resetRoute: string = "/refreshPage") {
  let handler: any;

  const refresh = (path: string) => {
    navigate(resetRoute);
    handler = setTimeout(() => navigate(path), 10);
  };

  useEffect(() => {
    return () => handler && clearTimeout(handler);
  }, [handler]);

  return refresh;
}